<div class="modal-header">Conferma</div>
<div class="modal-body">
  {{title}}
</div>
<div class="modal-footer">

  <button
    type="button"
    nbButton
    status="warning"
    outline
    (click)="closeModal()"
    *ngIf="show_annulla"
  >Annulla</button>

  <button
    type="button"
    nbButton
    status="primary"
    (click)="cambiaAuth(auth_status)"
    *ngIf="show_autorizza"
  >{{auth_button}}</button>

  <button
    type="button"
    nbButton
    status="primary"
    (click)="forceAuth(auth_status)"
    *ngIf="show_forza"
  >{{force_button}}</button>

  <button
    type="button"
    nbButton
    status="primary"
    (click)="cambiaAuth(require_status)"
    *ngIf="show_richiedi"
  >{{require_button}}</button>

  <button
    type="button"
    nbButton
    status="danger"
    (click)="cambiaAuth(deny_status)"
    *ngIf="show_nega"
  >{{deny_button}}</button>

</div>
